"use client";

import React from "react";
import Image from "next/image";
import { Spinner, SpinnerType } from "@/components/ui/spinner";

const LoadingScreen = () => {
  return (
    <div className="mb-6 flex flex-col items-center font-medium sm:mb-8">
      <h1 className="mb-2 text-[32px] leading-[38.4px] text-ttwilight-navy sm:text-[61px] sm:leading-[91.5px]">
        <span className="welcomeTitle italic text-primary">Welcome</span> back
      </h1>
      <span className="font-AeonikProLight text-center text-base font-normal text-grey-subtext">
        Loading...
      </span>

      <div className="flex flex-col items-center justify-center">
        <Spinner size="48" color="#1e40af" type={SpinnerType.Circular} />
      </div>
    </div>
  );
};

export default LoadingScreen;
